/* unplugin-vue-components disabled */// extracted by extract-css-chunks-webpack-plugin
module.exports = {"NotificationsContainer":"NotificationsContainer_8fDzr","notificationItem":"notificationItem_-jAP3"};